import React, { useContext } from 'react'
import './ProductDisplay.css'
import star_icon from '../Assets/star_icon.png'
import star_dull_icon from '../Assets/star_dull_icon.png'
import { ShopContext } from '../../Context/ShopContext'

export const ProductDisplay = (props) => {
    const {product} = props;
    const {addToCart} = useContext(ShopContext);
  return (
    <div className='productdisplay'>
        <div className="productdisplay-left">
<div className="productdisplay-img-list">
    {/* <img src={product.imaage} alt="" />
    <img src={product.imaage} alt="" />
    <img src={product.imaage} alt="" />
    <img src={product.imaage} alt="" /> */}
</div>
<div className="productdisplay-img">
    <img className='productdisplay-main-img'   src={product.image} alt="" />
</div>
        </div>
        <div className="productdisplay-right">
<h1>{product.name}</h1>star_icon
<div className="productdisplay-right-star">
    <img src={star_icon} alt="" />
    <img src={star_icon} alt="" />
    <img src={star_icon} alt="" />
    <img src={star_icon} alt="" />
    <img src={star_dull_icon} alt="" />
    <p>(122)</p>
</div>
<div className="productdisplay-right-size">
    <h1>Select Size</h1>
    <div className="productdisplay-right-size">
<div>S</div>
<div>M</div>
<div>L</div>
<div>XL</div>
<div>XXL</div>
    </div> <br />
    <div className='price' > Price - $ {product.new_price}  <h4 className='oldprice'>{product.old_price} </h4> 

    </div>
  
</div>
<button className='addtocart'  onClick={()=>{addToCart(product.id)}}>ADD TO CART</button>
<p className='productdisplay-right-category'>
    <span>Category:</span> Women ,T-Shirt, Crop Top
</p>
<p className='productdisplay-right-category'>
    <span>Tags:</span> Modern, Latest
</p>

</div>
        </div>
   
  )
}
